<button (click)="GetPlanNotificationList()"><span *ngIf="this.notificationCount>0">{{this.notificationCount}}</span><i class="icon-notification_icon"></i></button>
<div *ngIf="showPlanNotification">        
  <app-PlanNotification #PlanNotificationComponentpage></app-PlanNotification>
</div>